import { forwardRef, type SVGProps } from 'react';

export type DashedPlusProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const DashedPlus = forwardRef<SVGSVGElement, DashedPlusProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="currentColor" viewBox="0 0 32 32">
    <path
      d="M16 11v10m5-5H11m-7-3v6m24-6v6M19 4h-6m6 24h-6m-4.6 0H4v-3.5m24 0V28h-4.36m0-24H28v3.5m-24 0V4h4.4"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
));
DashedPlus.displayName = 'DashedPlus';
